<table class="table-fixed w-full table-striped">
  <thead class="h-[50px] w-full !z-30 sticky top-0 bg-[#1A4971]">
    <tr class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6]">
      <th class="p-2 !text-left">Scope</th>
      <th class="p-2 !text-left">Role</th>
      <th class="p-2 !text-left">Permission</th>
      <th class="p-2 !text-center">Action</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="roles && roles?.length > 0">
      <tr
        *ngFor="let role of roles; let i = index"
        class="hover:bg-muted/50 !font-Roboto !cursor-default !h-[43px]"
      >
        <td class="border-b p-2 !text-left">
          {{ role?.scope === "global" ? "Global" : "Organization" }}
        </td>
        <td class="border-b p-2 !text-left">
          {{ role?.name }}
        </td>
        <td class="border-b p-2 !text-left">
          <span *ngIf="role.permissions && role.permissions.length > 0">
            {{ getPermissionNames(role?.permissions) }}
          </span>
        </td>
        <td class="border-b p-2 !text-center">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editRole(role)">
              <mat-icon color="primary">edit</mat-icon> Edit
            </button>
            <button mat-menu-item (click)="deleteRole(role?.id)">
              <mat-icon color="warn">delete</mat-icon> Delete
            </button>
            <button
              mat-menu-item
              (click)="openViewDetailDialog(role)"
              class="!mb-[3px]"
            >
              <mat-icon class="!text-[#e76b3f]">visibility</mat-icon>
              <span>View Details</span>
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<!-- Empty State -->
<div *ngIf="roles?.length === 0" class="empty-state text-center pt-5 pb-5">
  No roles found. Please add a new role.
</div>

<!-- Inline Role Dialog Template -->
<ng-template #addRoleDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">
        {{ editRoleId ? "Update Existing Role" : "Add New Role" }}
      </h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <form [formGroup]="roleForm" (ngSubmit)="createRole()">
      <div class="grid grid-cols-2 gap-4">
        <!-- First Name -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Role Name</mat-label>
            <input
              matInput
              type="text"
              id="roleName"
              formControlName="roleName"
              placeholder="Enter Role Name"
            />
            <mat-error
              *ngIf="
                roleForm.get('roleName')?.invalid &&
                roleForm.get('roleName')?.touched
              "
            >
              Role Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Role Scope (Global/Org-specific) -->
        <div>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Scope</mat-label>
            <mat-select formControlName="scope">
              <mat-option value="global">Global</mat-option>
              <mat-option value="organization">Organization</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Permissions List -->
      <h3 class="text-[18px] font-semibold text-[#343A40]">
        Role’s Permissions
        <span class="text-[#E76B3F] cursor-pointer" (click)="resetPermissions()"
          >(Reset)</span
        >
      </h3>
      <div class="grid grid-cols-2 gap-4 !w-[60%]">
        <div *ngFor="let permission of permissions" class="ml-[-8px]">
          <mat-checkbox
            [checked]="selectedPermissions.includes(permission.id)"
            (change)="togglePermission(permission.id)"
            class="custom-checkbox"
          >
            {{ permission.name | titlecase }}
          </mat-checkbox>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="dialog-actions">
        <button class="submit-btn" type="submit" [disabled]="roleForm.invalid">
          {{ editRoleId ? "Update Role" : "Add Role" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Role Detail Dialog Template -->
<ng-template #viewDetailDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">
        {{ roleDetail?.name }} - has the following permissions:
      </h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <div class="grid grid-cols-2 gap-4 bg-gray-100 p-4 rounded-lg shadow-md">
      <div
        *ngFor="let permission of roleDetail?.permissions"
        class="bg-white p-3 rounded-lg shadow-sm border border-gray-200 text-gray-700 text-sm font-medium"
      >
        {{ permission.name | titlecase }}
      </div>
    </div>
  </div>
</ng-template>
